export default __webpack_public_path__ + "static/media/UK27_about_image_1.61419059.jpg";